import { useInfiniteQuery } from 'react-query';

import { getDataStories as queryFn } from 'api/endPoints/getDataStories';
import { QueryKeys } from 'api/queryKeys';

import { IFilter } from 'components/Dashboards/Project/Components/CustomDashboard/utils/utils.type';

export const useQueryGetDataStories = (params: QueryParams, endpoint?: string) => {
    return useInfiniteQuery<QueryResponse, QueryError, QueryResponse, [QueryKeys, unknown]>({
        queryKey: ['dataStories', params],
        queryFn: () => queryFn(params, endpoint),
        enabled: Boolean(params.projectId),
        getNextPageParam: (lastPage, allPages) => {
            if (lastPage.dataStory.length === 0) {
                return undefined;
            }
            const page = allPages.length * 4;
            const size = page + 4;
            return { page, size };
        },
    });
};

interface QueryParams {
    filter: {
        filter: {
            filters: IFilter[];
        };
    };
    pageParam: { page: number; size: number };
    projectId: number | undefined;
}

export interface QueryResponse {
    tags: {
        id: number;
        name: string;
    }[];
    dataStory: {
        id: number;
        createdDate: number;
        title: string;
        description: string;
        embeddedCode: string;
        imageLink: string | null;
        createdBy: string;
        createdByUsername: string;
        tagslist: {
            id: number;
            name: string;
        }[];
        imageName: string | null;
        contractName: string;
        mentionedList: string[];
    }[];
    startDate: number | null;
    endDate: number | null;
    token: string | null;
}
